import { default as indexrXKRnLbgEoMeta } from "/apps/web/pages/contact/index.vue?macro=true";
import { default as indexFJfs5b7qM5Meta } from "/apps/web/pages/index.vue?macro=true";
import { default as _91news_93ktpGRPfWv2Meta } from "/apps/web/pages/news/[news].vue?macro=true";
import { default as indexKqW15uuCWhMeta } from "/apps/web/pages/news/index.vue?macro=true";
export default [
  {
    name: "contact___ja___default",
    path: "/contact",
    meta: indexrXKRnLbgEoMeta || {},
    component: () => import("/apps/web/pages/contact/index.vue").then(m => m.default || m)
  },
  {
    name: "contact___ja",
    path: "/ja/contact",
    meta: indexrXKRnLbgEoMeta || {},
    component: () => import("/apps/web/pages/contact/index.vue").then(m => m.default || m)
  },
  {
    name: "contact___en",
    path: "/en/contact",
    meta: indexrXKRnLbgEoMeta || {},
    component: () => import("/apps/web/pages/contact/index.vue").then(m => m.default || m)
  },
  {
    name: "index___ja___default",
    path: "/",
    meta: indexFJfs5b7qM5Meta || {},
    component: () => import("/apps/web/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___ja",
    path: "/ja",
    meta: indexFJfs5b7qM5Meta || {},
    component: () => import("/apps/web/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexFJfs5b7qM5Meta || {},
    component: () => import("/apps/web/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "news-news___ja___default",
    path: "/news/:news()",
    meta: _91news_93ktpGRPfWv2Meta || {},
    component: () => import("/apps/web/pages/news/[news].vue").then(m => m.default || m)
  },
  {
    name: "news-news___ja",
    path: "/ja/news/:news()",
    meta: _91news_93ktpGRPfWv2Meta || {},
    component: () => import("/apps/web/pages/news/[news].vue").then(m => m.default || m)
  },
  {
    name: "news-news___en",
    path: "/en/news/:news()",
    meta: _91news_93ktpGRPfWv2Meta || {},
    component: () => import("/apps/web/pages/news/[news].vue").then(m => m.default || m)
  },
  {
    name: "news___ja___default",
    path: "/news",
    meta: indexKqW15uuCWhMeta || {},
    component: () => import("/apps/web/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: "news___ja",
    path: "/ja/news",
    meta: indexKqW15uuCWhMeta || {},
    component: () => import("/apps/web/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: "news___en",
    path: "/en/news",
    meta: indexKqW15uuCWhMeta || {},
    component: () => import("/apps/web/pages/news/index.vue").then(m => m.default || m)
  }
]